module.exports = __webpack_public_path__ + "static/media/system_flow_estimate_calender.f8e64059.svg";